var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 30,
    fill: "url(#pattern54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern54",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4106_9073",
    transform: "translate(-0.00167224) scale(0.0334448 0.025641)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4106_9073",
    width: 30,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAnCAYAAAAYRfjHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHqADAAQAAAABAAAAJwAAAABmcO3yAAABp0lEQVRYCe2W4U3DMBCFU+B/ywYwAeoEqCMwAS0LABMgJoAJSJkgnYAVGKFiAaADoPJemosuJnZssJMf1NLpLs3d+3yXpEmW7dY13Bq2jWDUuYN1rhtkxACaGkUXmTs0i2Id5y64hhwgMcRmHptuhROSYl0p0TniVniKjtnQAqa1f8D1yZAxM9c2atFxwlOCrZ0fYdep13MFeKr8HP4tFfirgtjcJUcxxDoZCpyN0C5vLlmHEgT4d+SOA/LL1Bgd30JpEwqO0bEwzyVw+Bc5FxMsmi5f3+0xRu0CWc/twdbRtJw4w2/Bj5HW+c1LYgaBD9gaNoXxkvmYZjXemT7FC0C0ADdwkRr8aED1BvjR2LVxnd/Yva3wGKKFAyqCOXKYa9ORPPpO8ClyXo08LWDGzLXBda4TPIUIr6Eu8IlZw1qzc13bENWJ5k2ki3xiwqmhNXVdK/geBTrpL/GDgmudBoDXJo8IFVABTWrL8XZUHcCVq+tDoH67SIHhves5/0HWHtzb2P/fqPk4fcLGvc14B9pw1KueocSVzAmCJYyd1/8siWIylrDJNxbvQVjINy5wAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.40703626fcb6a3d5f2abaf0604baaeb7.svg";
export { ForwardRef as ReactComponent };